import { put, takeLatest, select } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { addDays, isAfter } from 'date-fns';
import { TOGGLE_ALL_SEGMENTS, TOGGLE_SEGMENT, SET_SEGMENT_DATE, setSegmentDate, clearSegmentsDate } from './actions';
import { getIsAllSegmentsSelected, getSegments } from './selectors';
import { clearExchangeVariants } from '../exchangeVariants/actions';
import { getSelectedFlightsCount } from '../exchangeVariants/selectors';
function* resetSegmentsDate() {
    const selectedFlightsCount = yield select(getSelectedFlightsCount);
    if (selectedFlightsCount) {
        yield put(clearExchangeVariants());
    }
    yield put(clearSegmentsDate());
}
function* setCorrectSegmentDates() {
    var _a, _b;
    const isAllSegments = yield select(getIsAllSegmentsSelected);
    if (!isAllSegments) {
        return;
    }
    const segments = yield select(getSegments);
    let correctDateSegmentAction = null;
    let index = 0;
    while (!correctDateSegmentAction && index < segments.length - 1) {
        const segment = segments[index];
        const nextSegment = segments[index + 1];
        const segmentDate = (_a = segment.selectedDate) !== null && _a !== void 0 ? _a : segment.date;
        const nextSegmentDate = (_b = nextSegment.selectedDate) !== null && _b !== void 0 ? _b : nextSegment.date;
        if (isAfter(segmentDate, nextSegmentDate)) {
            correctDateSegmentAction = setSegmentDate({
                id: nextSegment.id,
                date: addDays(segmentDate, 1)
            });
        }
        index++;
    }
    if (correctDateSegmentAction) {
        yield delay(10);
        yield put(correctDateSegmentAction);
    }
}
export function* segmentsSagas() {
    yield takeLatest([TOGGLE_ALL_SEGMENTS, TOGGLE_SEGMENT], resetSegmentsDate);
    yield takeLatest(SET_SEGMENT_DATE, setCorrectSegmentDates);
}
